import {
  getPaymentChannels,
  postGenerateLaoQR,
  postPaymentStatus,
} from "../api/paymentApi";
import { LaoQrModel, PaymentChannelModel } from "../types/payment";

export const fetchAllPaymentChannels = async (): Promise<
  PaymentChannelModel[]
> => {
  const data = await getPaymentChannels();
  const paymentChannels = data.data.map((channel) => ({
    uuid: channel.uuid,
    channel: channel.channel,
    status: channel.status,
  }));
  return paymentChannels;
};

export const checkOrderStatus = async (orderId: string) => {
  const response = await postPaymentStatus(orderId);
  return response;
};

export const generateLaoQr = async (
  paymentChannelId: string,
  orderId: string
): Promise<LaoQrModel> => {
  try {
    const result = await postGenerateLaoQR(paymentChannelId, orderId);

    // Validate response based on your backend structure
    if (!result.emv || !result.payment_ref) {
      throw new Error("Invalid QR response: missing EMV or payment reference");
    }

    if (result.code !== "000") {
      throw new Error(result.message || "QR generation failed");
    }

    return {
      emv: result.emv,
      payment_ref: result.payment_ref,
      qr_expiry: result.qr_expiry,
    };
  } catch (error: any) {
    console.error("❌ Failed to generate QR code:", error);

    // Enhanced error handling based on your backend error codes
    if (error.response?.data?.code === "001") {
      throw new Error(
        error.response.data.message || "Payment channel or order not found"
      );
    } else if (error.response?.data?.code === "003") {
      throw new Error("Payment service is temporarily unavailable");
    } else if (error.response?.status === 500) {
      throw new Error("Internal server error occurred");
    }

    throw new Error(error.message || "Failed to generate QR code");
  }
};

// ✅ Helper function to determine payment status from API response
export const getPaymentStatusFromResponse = (response: any): string => {
  // Customize this based on how your API indicates payment status
  switch (response.code) {
    case "000":
      return "success";
    case "001":
      return "not_found"; // Payment not found
    case "002":
      return "pending";
    case "003":
      return "error";
    default:
      return "pending";
  }
};
